import {type PropsWithChildren, useEffect} from "react";
import {useSelector} from "react-redux";

import {ErrorType} from "config/errors";
import {addBreadcrumb} from "config/sentry";
import {useI18n} from "i18n/i18n";

import {globalErrorSelector} from "webform/store/selectors";

import {Error} from "../Error";

export const FullscreenErrorHandler = ({children}: PropsWithChildren) => {
    const errorTypes = useSelector(globalErrorSelector);
    const errorType = errorTypes.length > 0 ? errorTypes[0] : undefined;

    const i18n = useI18n();

    // Derive the error screen straight from errorType (no mirrored state) and log the
    // breadcrumb as a side effect — the monolith's setState-in-effect + log-in-render
    // pattern trips the workspace's react-compiler lint and is behaviour-equivalent.
    useEffect(() => {
        if (errorType) {
            addBreadcrumb("Displaying fullscreen error message", "error", {errorType});
        }
    }, [errorType]);

    if (errorType === undefined) {
        return <>{children}</>;
    }

    switch (errorType) {
        case ErrorType.INCORRECT_CASE_STATE:
        case ErrorType.TOKEN_EXPIRED:
        case ErrorType.ASSERT_WEBFORM_AVAILABLE_FETCH_FAILED:
            return <Error description={i18n("webform.error.incorrect_case_state")} />;
        case ErrorType.USER_PERSONA_FETCH_FAILED:
        case ErrorType.SUBMIT_FORM_FAILED:
        case ErrorType.GET_CITIES_FETCH_FAILED:
            return <Error description={i18n("webform.error.generic_description")} />;
        default:
            return <>{children}</>;
    }
};
